import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import EmptyState from './EmptyState';
import OcularHit from './OcularHit';

import type { SearchOcularDBHit } from '../types';

import './style.scss';

const RenderItem = (hit: SearchOcularDBHit) => <OcularHit hit={hit} />;

const SearchOcularDBResults: React.FC<Omit<Results, 'renderItem' | 'emptyState'>> = (props) => {
  const { className } = props;

  const classNames = c('Search__Results', 'SearchOcularDB__Results', className);

  return (
    <SearchResults
      className={classNames}
      renderItem={RenderItem}
      emptyState={<EmptyState />}
    />
  );
};

export default SearchOcularDBResults;
